function equal(a, b) {
    if (a === b) return true;
  
    if (a && b && typeof a == 'object' && typeof b == 'object') {
      if (a.constructor !== b.constructor) return false;
  
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;)
          if (!equal(a[i], b[i])) return false;
        return true;
      }
  
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
  
      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;
  
      for (i = length; i-- !== 0;)
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
  
      for (i = length; i-- !== 0;) {
        var key = keys[i];
  
        if (!equal(a[key], b[key])) return false;
      }
  
      return true;
    }
  
    // true if both NaN, false otherwise
    return a!==a && b!==b;
  };
  
  
  let activeRender;
  let subscribers = new WeakMap();
  
  
  const isPrimitive = (value) => {
    return (
      value === null ||
      !(typeof value === 'object' || typeof value === 'function'));
  };
  
  
  export var support = {};
  var tests = {
    touch:        typeof window === 'undefined' ? false : function(){ return 'ontouchstart' in window || /*|| (navigator.maxTouchPoints > 0)*/navigator.msMaxTouchPoints > 0; },
    msPointer:    typeof window === 'undefined' ? false : function(){ return !!window.navigator.msPointerEnabled; },
    pointer:      typeof window === 'undefined' ? false : function(){ return !!window.navigator.pointerEnabled; },
    pointerdown:  function(){ return this.touch() ? 'touchstart' : this.pointer() ? 'pointerdown' : this.msPointer() ? 'MSPointerDown' : 'mousedown'; },
    pointerup:    function(){ return this.touch() ? 'touchend' : this.pointer() ? 'pointerup' : this.msPointer() ? 'MSPointerUp' : 'mouseup'; },
    pointermove:  function(){ return this.touch() ? 'touchmove' : this.pointer() ? 'pointermove' : this.msPointer() ? 'MSPointerMove' : 'mousemove'; },
    pointerenter: function(){ return this.touch() ? 'touchstart' : this.pointer() ? 'pointerenter' : this.msPointer() ? 'MSPointerEnter' : 'mouseenter'; },
    pointerleave: function(){ return this.touch() ? 'touchend' : this.pointer() ? 'pointerleave' : this.msPointer() ? 'MSPointerLeave' : 'mouseleave'; },
    pointerover:  function(){ return this.touch() ? 'touchstart' : this.pointer() ? 'pointerover' : this.msPointer() ? 'MSPointerOver' : 'mouseover'; },
    pointerout:   function(){ return this.touch() ? 'touchend' : this.pointer() ? 'pointerout' : this.msPointer() ? 'MSPointerOut' : 'mouseout'; },
  }
  var featureName;
  for (var feature in tests) {
    if (tests.hasOwnProperty(feature)) {
      featureName = feature;
      support[featureName] = tests[feature]();
    }
  }
  
  const EXP_REG = /\$\$([0-9]+)\$\$/g;
  function hyphenise(str) {
    return str.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
  }
  
  var attachedEvents = {};
  function delegateHandler(e) {
    for (let i=0; i<attachedEvents[e.type].length; i++) {
      let isTarget = false
      let node = e.target;
      let evt = attachedEvents[e.type][i]
      while(node != document && node.parentNode) {
        if (evt.target == node) {
          isTarget = true
          break;
        }
        node = node.parentNode
      }
      if (isTarget) {
        let newEvent = JSON.parse(JSON.stringify(e))
        newEvent.currentTarget = evt.target
        newEvent.stopPropagation = (e)=>{ console.warn('todo: stopPropagation') }
        newEvent.preventDefault  = (e)=>{ console.warn('todo: preventDefault') }
        evt.callback(newEvent);
      }
    }
  }
  function delegateEvent(target, eventName, callback) {
    if (!attachedEvents[eventName]) {
      attachedEvents[eventName] = []
      document.addEventListener(eventName, delegateHandler)
    }
    attachedEvents[eventName].push({target, callback})
  }
  
    class Binding {
      constructor(options) {
        this.oldValue = null
        this.node = options.node;
        this.lvls = options.lvls
        this.optional = options.optional
        this.nameIndex = options.nameIndex
        this.valueIndex = options.valueIndex
        this.name = options.name
        this.value = options.value
        this.type =options.type
        this.index =options.index
  
        if (/\?/g.test(this.name) ) {
          this.optional = true
          this.node.removeAttribute( this.name )
          this.name = this.name.replace(/\?/g, '')
        }
        /**
         * Even if some browser support the native is="", Safari doesnt
         * So we patch this attribute to make sure all brosers begave the same
         */
        // if (/(data\-)?is$/g.test(this.name) ) {
        //   this.optional = true
        //   this.node.removeAttribute( this.name )
        //   this.name = this.name.replace(/(data\-)?is$/g, '$is')
        //   this.node.setAttribute( this.name, this.value )
        //   // let newNode = document.createElement( this.value )
        //   // this.node.removeAttribute('data-is');
        //   // Array.from(this.node.attributes).forEach(node => 
        //   //   newNode.setAttributeNode(node.cloneNode(true))
        //   // );
        //   // this.node.parentNode.replaceChild(newNode, this.node);
        //   // this.node = newNode;
        // }
        // if (/\.data/g.test(this.name) ) {
        //   this.isProperty = true
        // }
        if (/(on\-|\@)/.test(this.name)) {
          this.type = 'event'
          let eventName = this.name.replace(/^(on\-|\@)/,'');
          this.eventName = support[eventName] || eventName;
          this.eventHandler = this.eventHandler.bind(this)
          // delegateEvent( this.node, eventName, this.eventHandler );
          this.node.removeEventListener(this.eventName, this.eventHandler)
          this.node.addEventListener(this.eventName, this.eventHandler)
        }
        if (this.type == 'text'){
          this.parts = [];
          let lastIndex = 0;
          let originValue = this.node.nodeValue;
          originValue.replace(EXP_REG, (a,b,c)=>{
            this.parts.push({
              type:'static',
              str: originValue.substr(lastIndex, c-lastIndex) 
            })
            this.parts.push({
              type:'value',
              index: b>>0}
            );
            lastIndex = c + a.length;
            return a;
          })
          this.parts.push({
            type:'static',
            str: originValue.substr(lastIndex, originValue.length) 
          })
          this.node.nodeValue = ''
        }
      }
      eventHandler(e) {
        this.callback && this.callback(e)
      }
      destroy() {
        if (this.eventName && this.node) {
          this.node.removeEventListener(this.eventName, this.eventHandler)
        }
        this.node = null;
      }
      _update(values) {
  
        if (this.type=='event') {
          let value = this.valueIndex != -1  ? values[this.valueIndex] : this.value
          if ( this.callback?.toString() !== value?.toString() ) {
            this.callback = value
          }
        }
        if (this.type=='text') {
          let parent = this.node.parentNode
  
          this.parts.forEach((part)=>{
            if (values[part.index] == void 0) {
              return
            }
            if ( part.type == 'value' ) {
              if ( Array.isArray(values[part.index]) ) 
              {
                part.entries = part.entries || []
  
                values[part.index].forEach((item, itemIndex)=>{
                  if (item.htmlTemplate) {
                    if(part.entries[itemIndex] == undefined) {
                      part.entries[itemIndex] = new TemplateInstance( item.htmlTemplate, parent )
                    }
                    part.entries[itemIndex].render(item.values)
                  }
                });
                //remove unsued TemplateInstances
                for(let i=values[part.index].length; i<part.entries.length; i++) {
                  part.entries[i] && part.entries[i].destroy()
                }
                part.entries.splice(values[part.index].length, part.entries.length)
  
              }
              else if ( values[part.index].htmlTemplate ) 
              {
                if (!part.htmlTemplate || (part.htmlTemplate && values[part.index].htmlTemplate !== part.htmlTemplate) ) {
                  part.template && part.template.destroy()
                  part.htmlTemplate = values[part.index].htmlTemplate
                  part.template = new TemplateInstance( values[part.index].htmlTemplate, parent )
                }
                part.template.render(values[part.index].values)
              }
              else {
                if (!part.node) {
                  part.node = document.createElement('span')
                  parent && parent.insertBefore( part.node, this.node )
                }
                if (part.node.oldText == void 0 || part.node.oldText != values[part.index] ) {
                  part.node.innerHTML = values[part.index]
                  part.node.oldText = values[part.index]
                }
              }
            }
            //Text node
            else 
            {
              if (!part.node) {
                part.node = document.createTextNode(part.str)
                parent.insertBefore( part.node, this.node )
              }
              if ((isPrimitive(value) || value !== this.value)) {
                if (part.node.nodeValue !== values[part.index]) {
                  part.node.nodeValue = values[part.index]
                }
              }
            }
          })
        }
        if (this.type=='attribute') {
  
          let value = this.valueIndex != -1 ? values[this.valueIndex] : this.value
          let name   = this.nameIndex != -1 ? values[this.nameIndex] : this.name
          
          if (name=="class") {
  
              // if (value) {
              
              let newClasses = !value || value == ''  || typeof value.trim != 'function' ? [] : value.trim().replace(/\s+/g,' ').replace(/(?:\r\n|\r|\n)/g, ' ').split(' ')
              
              if (this.oldValue && typeof this.oldValue.replace == 'function' ) {
                let oldValuesArr = this.oldValue.replace(/\s+/g,' ').replace(/(?:\r\n|\r|\n)/g, ' ').trim().split(' ');
                let filteredOldValuesArr = oldValuesArr.filter(oldClass => !newClasses.includes( oldClass ) && oldClass.trim() != '' )
                if (filteredOldValuesArr.length > 0) {
                  this.node.classList.remove.apply(this.node.classList, filteredOldValuesArr )
                }
                newClasses = newClasses.filter(newClass => !oldValuesArr.includes(newClass) )
              }
              newClasses = newClasses.filter(newClass => newClass.trim()!=='' )
              if (newClasses.length > 0) {
                this.node.classList.add.apply(this.node.classList, newClasses )
              }
  
            // }
            // else {
            // }
  
          }
          else if (name=="style" && typeof value == 'object') {
            //removable propety by setting its value to false or null
            if (this.oldValue && typeof this.oldValue == 'object') {
              for (let s in this.oldValue) {
                if (value[s] === void 0 || value[s] === null) {
                  this.node.style.removeProperty( hyphenise(s) );
                }
              }
            }
            for (let s in  value) {
              if (value[s] !== void 0 && value[s] !== null) {
                this.node.style[s] = value[s];
              }
            }
          }
          else if (this.node.props && this.node.set && (this.name in this.node.props) ) {
            this.node.set({
              [this.name]: value
            })
          }
          else {
            if (this.nameIndex != -1 || (this.optional && !value) ) {
              if (this.node.hasAttribute(name)) {
                this.node.removeAttribute(name)
              }
            }
            else {
              if (this.oldValue == void 0 || typeof this.oldValue === 'object' || (this.oldValue !== value) ) {
                this.node.setAttribute(name, typeof value == 'object' ? JSON.stringify(value) : value  );
              }
            }
          }
          this.oldValue = value;
        }
      }
    }
  
    let templateCache = new Map();
    class TemplateInstance {
      constructor(options, parentNode) {
  
        this.parentNode = parentNode;
        this.bindings   = []
        
        this.templateTag = options.templateTag
        let c2           = options.templateTag.content.cloneNode(true)
        let $wrapper     = document.createElement('div')
        $wrapper.appendChild( c2 )
        let c = $wrapper;
  
        /** Fixing IOs 11 Autoplay bug on cloned videos from document fragment */
        let videos = c.querySelectorAll('video')
        videos.forEach(vid=>{
          if (!vid._isClone && !vid._clone) {
            let $cloneVideo = vid.cloneNode();
            vid._clone = $cloneVideo;
            $cloneVideo._isClone = true
            $cloneVideo.setAttribute('is-clone','') 
            vid.parentNode.insertBefore( $cloneVideo, vid )
            vid.parentNode.removeChild( vid )
          }
        });
        /**/
      
        this.rootNodes = []
        for (let i=0; i<c.childNodes.length; i++) {
          this.rootNodes.push( c.childNodes[i] )
        }
  
        //connect binding with corresponding node in cloned template content
        options.bindingOptions.forEach( binding => {
          let n = c;
          binding.lvls.forEach( lvl => {
            n = n.childNodes[lvl];
          })
          binding.node = n;
          this.bindings.push(new Binding(binding))
        });
  
        this.rootNodes.forEach((n)=>{
          this.parentNode.appendChild( n )
        })
  
      }
  
      render(values) {
        this.bindings.forEach( binding => {
          binding._update(values)
        });
      }
      destroy() {
        this.bindings.forEach( binding => {
          binding.destroy()
        });
        this.rootNodes.forEach((n)=>{
          n && n.parentNode && n.parentNode.removeChild(n)
        })
        this.rootNodes = [];
      }
    }
  
  
  
    function getBindings(node, bindings, lvls) {
      if (node.nodeType == Node.TEXT_NODE) {
        if ( EXP_REG.test(node.nodeValue) ) {
          bindings.push({lvls, type:'text'} );
        }
      }
      else if (node.attributes) {
  
        for (let a = 0; a<node.attributes.length; a++) {
        
          let attr = node.attributes[a]
        
          if (!EXP_REG.test(attr.name) && !EXP_REG.test(attr.value)) 
            continue
        
          let attrName   = attr.name
          let nameIndex  = -1
          let valueIndex = -1
          
          attr.name.replace(EXP_REG, (a,b)=>{
            nameIndex = b>>0
            node.removeAttribute( attrName )
            bindings.push({
              lvls, 
              nameIndex, 
              valueIndex,
              name:  attrName, 
              value: attr.value, 
              type:  'attribute'
            })
          });
  
          attr.value.replace(EXP_REG, (a,b)=>{
            valueIndex = b>>0
            bindings.push({
              lvls, 
              nameIndex, 
              valueIndex,
              name:  attrName, 
              value: attr.value, 
              type:  'attribute'
            })
          });
          
        }
      }
      if (node.childNodes) {
        for (let i=0; i<node.childNodes.length; i++) {
          let newlvls = JSON.parse(JSON.stringify(lvls))
          newlvls.push( i )
          getBindings( node.childNodes[i], bindings, newlvls)
        }
      }
    }
  
    class HTMLTemplate {
      constructor(strings, values) {
        this.bindingOptions = []
        let filteredString = '';
        for (let i=0; i<strings.length; i++) {
          let value = '';
          if (i < strings.length-1) {
            value = '$$'+i+'$$'
          }
          filteredString += strings[i] + value; 
        }
        this.templateTag = document.createElement('template')
        this.templateTag.innerHTML = filteredString;
        getBindings(this.templateTag.content, this.bindingOptions, [])
        this.values    = values
      }
    }
  
  
  export function html(strings, ...values) {
    let htmlTemplate = templateCache.get(strings);
    if (!htmlTemplate) {
      htmlTemplate = new HTMLTemplate(strings, values)
      templateCache.set(strings, htmlTemplate);
    }
    return {htmlTemplate, values};
  }
  
  
  function getSubscribersForProperty(target, key) {
    if (!subscribers.get(target)) {
      subscribers.set(target, {});
    }
    let sub = subscribers.get(target)
    sub[key] = sub[key] || [] 
    return sub[key]
  }
  
  function trackDependencies(target, key) {
    if (activeRender && typeof target[key] !== 'function') {
      const subs = getSubscribersForProperty(target, key)
      if (!subs.includes(activeRender)) {
        subs.push(activeRender)
      }
    }
  }
  
  function triggerChange(target, key, value) {
    const components = getSubscribersForProperty(target, key)
    components.forEach((component) => defer(component) )
  }
  
  export function proxify(obj) {
      
    if (!obj || typeof obj !== 'object' || obj.__isProxy) return obj
  
    for (let k in obj) {
      if (typeof obj[k] == 'object') {
        obj[k] = proxify(obj[k], obj, k)
      }
    }
    let prox = new Proxy(obj, {
      get(target, key) {
        if (key == "__isProxy") {
          return true;
        }
        if (key == '_proxy_target') {
          return target;
        }
        trackDependencies(target, key)
        return target[key];
      },
      set(target, key, value) {
          value = proxify(value)
          if ( isPrimitive(value) || value !== target[key] ) {
            triggerChange(target, key, value)
            target[key] = value;
          }
        return true;
      }
    })
    return prox
  }
  
  
  let UUID = 0
  
  export class Component extends HTMLElement {
  
      get defaultData() {
        return {}
      }
      constructor() {
        super()
        this.uuid = UUID++
  
        this._data = this.defaultData
        this.data = proxify(this._data)
  
        this.created && this.created();
        
        if (this.shadowDom) {
          this.attachShadow(this.shadowDom);
          // if there's a shadowRoot, append the local styles to the shadowDom to get scopped styles
          if (this.styles) {
            let $style = document.createElement("style");
            $style.textContent = this.styles
            this.shadowRoot.appendChild( $style )
          }
        }
        else {
          // no shadow root, append style tag to head
          // use the component name to avoid duplicating styles
          if (this.styles) {
            if ( !document.getElementById(this.tagName + '-style') ) {
              this.$componentStyle = document.createElement('style');
              this.$componentStyle.id = this.tagName + '-style'
              this.$componentStyle.setAttribute('id', this.tagName + '-style');
              this.$componentStyle.type = 'text/css';
              this.$componentStyle.innerHTML = this.styles;
              document.getElementsByTagName('head')[0].appendChild(this.$componentStyle);
            }
          }
        }
      }
  
      query(selector) {
        this.querySelector(selector)
      }
      queryAll(selector) {
        this.querySelectorAll(selector)
      }
      shadowQuery(selector) {
        this.shadowRoot?.querySelector(selector)
      }
      shadowQueryAll(selector) {
        this.shadowRoot?.querySelectorAll(selector)
      }
  
      fire(eventName, opt) {
        this.dispatchEvent( new CustomEvent(eventName, {detail: opt || null}) );
      }
  
      connectedCallback() {
        if (this.props) {
          for (let k in this.props) {
            this.hydrateFromAttribute(k)
          }
        }
        this.attached && this.attached();
        this._isConnected = true
        this._update()
        requestAnimationFrame(()=>{
          this.ready && this.ready();
          if (this.update || this.resize) {
            componentInstances.push(this)
          }
        })
      }
  
      hydrateFromAttribute(k) {
        if (!this.props[k]) {
          return
        }
        let type = this.props[k];
        if (this.props[k].type) {
          type = this.props[k].type
        }
  
        let defaultVal = this.props[k] && this.props[k].default
  
        let _k = k.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`)
        
        let attrName = this.hasAttribute('data-'+_k) ? 'data-'+_k : this.hasAttribute(_k) ? _k : null
  
        if (!attrName) {
          if (defaultVal != void 0) {
            this.data[k] = defaultVal;
          }
          return
        }
  
        let val = this.getAttribute(attrName)
  
        if (/\$\$[^\$]+\$\$/.test(val)) {
          return
        }
  
        if (type === Object) {
          try {
            this.data[k] = JSON.parse( val )
          }
          catch(e) {
            console.warn(`<${this.tagName.toLowerCase() + '>  '+this.getAttribute('name')} -  JSON parse error on attribute ${attrName}=${ val }`, e)
          }
          this.setAttribute(attrName, '$$'+k+'$$')
        }
        else if (type === Boolean) {
          this.data[k] = val === 'false' ? false : val === 'true' ? true : (!val?false:true)
        }
        else {
          this.data[k] = type( val )
        }
      }
  
      attributeChangedCallback(attrName, oldValue, newValue) {
        if (this.props) {
          this.hydrateFromAttribute(attrName)
        }
        this.attributeChanged && this.attributeChanged(attrName, oldValue, newValue);
        this._update()
      }
      
      disconnectedCallback() {
        this.detached && this.detached();
        
        this.innerHTML = ''
        this._isConnected = false
        
        if (this.update || this.resize) {
          for (let i=0; i<componentInstances.length; i++) {
            let component = componentInstances[i]
            if (component == this) {
              componentInstances.splice(i,1)
              break;
            }
          }
        }
        if (this.template) {
          this.template.destroy()
          this.template = null
        }
        if (this.$componentStyle && this.$componentStyle.parentNode) {
          this.$componentStyle.parentNode.removeChild( this.$componentStyle )
        }
      }
      set(data) {
        for (let p in data) {
          this.data[p] = data[p]
        }
      }
      _update() {
        
        if (!this.render) {
          return
        }
  
        const domWrapper = this.shadowRoot || this 
  
        activeRender = this
        let result = this.render(this.data);
        activeRender = null
  
        // if (equal(result.values, this.oldValues)) {
        //   return
        // } 
  
        if (this.hasAttribute('has-rendered') && !this.hasRendered && !this.forceRender) {
          domWrapper.innerHTML = ``
          // let bindingOptions = [] 
          // getBindings(this, bindingOptions, [])
          // this.bindings = []
          // bindingOptions.forEach( binding => {
          //   if (binding.type == 'event') {
          //   }
          //   else {
          //     let n = this 
          //     binding.lvls.forEach( lvl => n = n.childNodes[lvl] )
          //     binding.node = n
          //     this.bindings.push(new Binding(binding))
          //   }
          // });
          // // bindings.forEach( binding => binding._update(result.values) )
          // this.hasRendered = true
          // this.fromReHydration = true
          // this.afterRender && this.afterRender()
          // return 
        }
  
        // if (this.fromReHydration) {
        //   this.bindings.forEach( binding => binding._update(result.values) )
        // }
        // else {
          if (!this.template) {
            this.template = new TemplateInstance(result.htmlTemplate, domWrapper)
          }
          else {
            if (this.template.templateTag != result.htmlTemplate.templateTag) {
              this.template.destroy()
              this.template = new TemplateInstance(result.htmlTemplate, domWrapper)
            }
          }
          this.template.render(result.values);
        // } 
        
  
        this.hasRendered = true
        this.setAttribute('has-rendered','')
        this.afterRender && this.afterRender();
  
        this.oldValues = result.values
  
      }
    }
  
  
    let deferQueue = {}
    const COMPONENTS = {}
    var componentInstances = [];
    
    function defer(component){
      deferQueue[component.uuid] = component
    }
  
    function update(timestamp) {
      requestAnimationFrame( update );
      componentInstances.forEach((component)=>{
        component._isConnected && component.update && component.update(timestamp)
      });
      let deferQueueCopy = {...deferQueue} 
      deferQueue = {}
      for (let k in deferQueueCopy) {
        deferQueueCopy[k]._update()
      }
    }
    
    let lastVW = 0;
    let lastVH = 0;
    function resize() {
      // if (
      //     window.forceResize
      //   || lastVW != window.innerWidth
      //   || (window.innerWidth > 768) 
      // ) {
        componentInstances.forEach((component)=>{
          component.resize && component.resize()
        });
      // }
      lastVW = window.innerWidth;
      lastVH = window.innerHeight;
      window.forceResize = false
    }
  
    window.addEventListener('resize', resize, false)
    window.addEventListener('orientationchange', resize, false)
    resize()
    update();
  
  
    export function createStore(options=()=>{}) {
      
      let {actions, mutations, state, getters} = options
  
      let store = {
  
        state: proxify(state), 
        
        async commit(type, payload) {
          if (!mutations[type]) {
            return
          }
          let newState = mutations[type](this.state, payload)
          if (newState) {
            for (let k in newState) {
              this.state[k] = newState[k]
            }
          }
        }
        
      }
      
      for (let k in actions) {
        store[k] = actions[k]
      }
        
      let prox = new Proxy(store, {
        get(target, key) {
          if (getters[key]) {
            return getters[key](target.state);
          }
          return target[key];
        }
      })
  
      return prox
  }